import { AlarmPriorityDisplayTile } from "./AlarmPriorityDisplay";
export default AlarmPriorityDisplayTile;
